import React, { useCallback, useEffect, useState } from 'react';
import { Action, CollectionServer, deleteInArray, DropdownAction, errorCatch, FilterToQueryParameters, GET, GETWITH, JSXMap, Model, POST, QueryDetail, QueryOrder, QueryParam, QueryParametersToFilters, updateInArray, useAuth } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useSearchParams } from 'react-router-dom';

import Icofont from 'react-icofont';
import { Button, Checkbox, Space, Tooltip } from 'antd';
import PageLayout from '../../components/PageLayout';
import YImage from '../../../common/YImage';
import confirmKey from '../../components/ConfirmKeyModal';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../common/Context';
import EventListItem from '../../components/EventListItem';
import EmojiTextArea from '../../../common/EmojiTextArea';
import { getIndexColorLighter } from '../../../common/Tool';
import Link from 'antd/es/typography/Link';

dayjs.locale('ru');
var _ = require('lodash');

// POST - "/api/mastervkpostov/create" 
// GET - "/api/mastervkpostov/delete/{id}"
// GET - "/api/mastervkpostov/list"
// GET - "/api/mastervkpostov/byid/{id}"

// "/api/vkgroups/create"
// "/api/vkgroups/update"
// "/api/vkgroups/delete/{id}"
// "/api/vkgroups/list"
// "/api/vkgroups/byid/{id}"

// POST "/api/vkrepost/create"
// POST "/api/vkrepost/update"
// "/api/vkrepost/delete/{id}"
// "/api/vkrepost/list"
// "/api/vkrepost/byid/{id}"
// "/api/vkrepost/scan"

// "/api/vkownerrepost/list"
// "/api/vkownerrepost/byid/{id}"

// POST "/api/vkrepost/set-meropriyatie"
// POST "/api/vkownerrepost/update"

function VkRepostsTable(props) {
    const { auth,
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update } = props;
    // console.log(collection);

    const [groups, setGroups] = useState()
    // const [tableCells, setTableCells] = useState()
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (collection?.length) {
            setLoading(true)
            GETWITH(auth, `/api/vkgroups/list`,
                [
                    QueryOrder("prioritet", "DESC")
                ], ({ data }) => {
                    setGroups(data)
                    setLoading(false)
                }, (err) => errorCatch(err, () => setLoading(false)))
        }
    }, [collection])

    // useEffect(() => {
    //     if (master?.ID) {
    //         setLoading(true)
    //         GET(auth, `/api/vkrepost/list/${master?.ID}`, ({ data }) => {
    //             setTableCells(data)
    //             setLoading(false)
    //         }, (err) => errorCatch(err, () => setLoading(false)))
    //     }
    // }, [master?.ID, collection])

    // const createPost = useCallback(() => {
    //     setLoading(true)
    //     GET(auth, `/api/vkposts/createorupdate/${master?.ID}`, ({ data }) => {
    //         setCollection(data)
    //         setLoading(false)
    //     }, (err) => errorCatch(err, () => setLoading(false)))
    // }, [master?.ID])

    const EmojiField = useCallback((auth, item, value, onChange, onAfterChange) => {
        return (<EmojiTextArea
            rows={8}
            auth={auth}
            // item={item}
            value={value}
            onChange={onChange}
            onAfterChange={onAfterChange}
        />)
    }, [auth])

    // const editingCompleted = useCallback((item) => {
    //     POST(auth, `/api/razmeshcheniepostov/editingcompleted`, {
    //         ID: item?.ID,
    //         editingCompleted: !item?.editingCompleted
    //     }, ({ data }) => {
    //         setTableCells(o => updateInArray(o, data))
    //     }, errorCatch)
    // }, [auth, tableCells])

    const statistika = useCallback((all, events, published, viewed) => {
        return (<Tooltip title={<div>
            <div>
                <i className="fa fa-circle-o" style={{ fontSize: "11px" }}></i> Всего {all}
            </div>
            <div>
                <i className="fa fa-check-square-o" style={{ fontSize: "11px" }}></i> Мероприятий {events}
            </div>
            {/* <div>
                <i className="fa fa-clock-o" style={{ fontSize: "11px" }}></i> Ожидают {waiting}
            </div> */}
            <div>
                <i className="fa fa-check" style={{ fontSize: "11px", color: "green" }}></i> Опубликовано {published}
            </div>
            <div>
                <i className="fa fa-eye" style={{ fontSize: "11px" }}></i> Просмотрено {viewed}
            </div>
        </div>}>
            <div className='bg bg-orange dark-5'>
                <div>
                    <i className="fa fa-circle-o" style={{ fontSize: "11px" }}></i> {all}
                </div>
                <div>
                    <i className="fa fa-check-square-o" style={{ fontSize: "11px" }}></i> {events}
                </div>
                {/* <div>
                    <i className="fa fa-clock-o" style={{ fontSize: "11px" }}></i> {waiting}
                </div> */}
                <div>
                    <i className="fa fa-check" style={{ fontSize: "11px", color: "green" }}></i> {published}
                </div>
                <div>
                    <i className="fa fa-eye" style={{ fontSize: "11px" }}></i> {viewed}
                </div>
            </div>
        </Tooltip>)
    }, [auth])

    return (<div>

        <div className='scrollable' style={{ backgroundColor: "white", height:"80vh" }}>
            <table className="table fixed-header" style={{ fontSize: "13px", lineHeight: "normal" }}>
                <thead>
                    <tr>
                        <th className={`wrap fixed`} style={{ minWidth: "200px", backgroundColor: "white" }}>
                            <div className='bg bg-grey dark-1'>Название</div>
                        </th>
                        <th className="wrap fixed" style={{ left: "200px", minWidth: "50px", maxWidth: "50px", backgroundColor: "white" }}>
                            <div className='bg bg-orange dark-5 border-orange'>
                                {/* <i className="fa fa-share-square-o"></i> */}
                                <i className="fa fa-pie-chart"></i>
                            </div>
                        </th>
                        {JSXMap(groups, (item, cidx) => {
                            let color = getIndexColorLighter(cidx, 0.25);
                            return (<th className="wrap" style={{ minWidth: "175px", fontWeight: "300" }} key={cidx}>
                                <div className="bg bg-grey" style={{ backgroundColor: color }}>
                                    {/* {item?.nazvanie} */}
                                    <Link style={{ color: "rgba(0,0,0,0.85)" }} target='_blank' href={item?.ssilka}><i className="fa fa-external-link" style={{ fontSize: "11px" }}></i> {item?.nazvanie}</Link>
                                </div>
                            </th>)
                        })}
                    </tr>
                </thead>
                <tbody style={{ fontSize: "12px" }}>
                    {JSXMap(collection || [], (item, cidx) => {
                        let all = 0, events = 0, waiting = 0, published = 0, viewed = 0;
                        for (let i = 0; i < groups?.length; i++) {
                            let group = groups[i];
                            let o = item?.vkRepostOwnerPost?.find(e => e.ownerPostID == item?.ID && e.gruppaID == group?.ID)
                            if(o){
                                all++;
                            }
                            if (o && o?.fakticheskayaDataPublikatsii) {
                                published++;
                            }
                            if (o && o?.prosmotreno) {
                                viewed++;
                            }
                            // if (o && o?.dataVremya && !o?.faktVremyaPublikatsii) {
                            //     waiting++;
                            // }
                            if (o && o?.meropriyatieID) {
                                events++;
                            }
                        }
                        return (<tr key={cidx}>
                            <td className={`fixed fill`} style={{ minWidth: "200px", backgroundColor: "white", height: '1px' }}>
                                <div className={`bg ${(!!item.ispolnen) ? "bg-green dark-5" : "bg-grey light-5"}  pointer`} style={{ display: "flex", justifyContent: "space-between", padding: "3px" }}>
                                    <Action
                                        key="vkrepost"
                                        auth={auth}
                                        options={{
                                            initialValues: {
                                                ...item,
                                            }
                                        }}
                                        action={(values, unlock, close) => {
                                            POST(auth, `/api/vkownerrepost/update`, {
                                                ...item,
                                                ...values,
                                            }, ({ data }) => {
                                                setCollection(o => updateInArray(o, data))
                                                // update();
                                                close()
                                            }, err => errorCatch(err, unlock))
                                        }}
                                        object={item}
                                        form={Model}
                                        meta={[
                                            // {
                                            //     label: "Мероприятие",
                                            //     name: "meropriyatie",
                                            //     type: "object",
                                            //     mode: "dialog",
                                            //     modal: { width: "650px" },
                                            //     relation: {
                                            //         uiFilter: () => [
                                            //             {
                                            //                 label: "Дата начала",
                                            //                 name: "nachaloSorevnovaniya",
                                            //                 type: "date",
                                            //                 filterType: "range",
                                            //                 sort: true,
                                            //                 filter: true,

                                            //                 sorted: "ASC",
                                            //                 filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
                                            //             },
                                            //             {   // Тип мероприятия
                                            //                 label: "Тип мероприятия",
                                            //                 name: "tipMeropriyatiya",
                                            //                 filterType: "group",
                                            //                 display: (o) => o.opisanie,
                                            //                 sort: true,
                                            //                 filter: true
                                            //             },
                                            //             {   // Уровень мероприятия
                                            //                 label: "Уровень мероприятия",
                                            //                 name: "urovenMeropriyatiya",
                                            //                 filterType: "group",
                                            //                 display: (o) => o.opisanie,
                                            //                 sort: true,
                                            //                 filter: true
                                            //             },
                                            //             {   // Место проведения
                                            //                 label: "Место проведения",
                                            //                 name: "mestoProvedeniya",
                                            //                 filterType: "group",
                                            //                 display: (o) => o.name,
                                            //                 sort: true,
                                            //                 filter: true
                                            //             },
                                            //         ],
                                            //         displayString: (item) => {
                                            //             return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
                                            //         },
                                            //         display: (item) => {
                                            //             return (
                                            //                 <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                                            //                     <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                            //                         <YImage item={item} width={32} hidePreview={true} />
                                            //                     </div>

                                            //                     <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                            //                         <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                            //                             <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                                            //                         </div>
                                            //                         <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                            //                             <span style={{
                                            //                                 marginRight: "5px",
                                            //                                 borderRadius: "5px",

                                            //                                 // backgroundColor: "#f6214b",
                                            //                                 // color: "white",

                                            //                                 backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                            //                                 color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                                            //                                 fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",

                                            //                                 fontSize: "12px",


                                            //                                 boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                            //                                 padding: "2px 4px"
                                            //                             }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                            //                             <span>{item?.mestoProvedeniya?.name}</span>
                                            //                         </div>
                                            //                     </div>
                                            //                 </div>
                                            //             )
                                            //         },
                                            //         reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                                            //         type: "many-one",
                                            //     },
                                            //     queryFilter: [
                                            //         QueryDetail("combobox"),
                                            //         QueryOrder("nachaloSorevnovaniya", "DESC")
                                            //     ]
                                            // },
                                            // {
                                            //     label: "Дата и время",
                                            //     name: "dataVremya",
                                            //     type: "datetime"
                                            // },
                                            {
                                                label: "Тип ссылки для сайта",
                                                name: "tipSsilkiDlyaSaita",
                                                type: "object",
                                                relation: {
                                                    display: (item) => {
                                                        return item.opisanie
                                                    },
                                                    reference: { object: "TipiSsilokVSotsSetyakh", property: "ID" },
                                                    type: "many-one",
                                                },
                                                queryFilter: [
                                                    QueryOrder("ID", "ASC")
                                                ]
                                            },
                                            {
                                                label: "Текст ссылки на сайте",
                                                name: "tekstSsilkiNaSaite",
                                                type: "string"
                                            },
                                            {
                                                label: "Мероприятие",
                                                name: "meropriyatie",
                                                type: "object",
                                                mode: "dialog",
                                                modal: { width: "650px" },
                                                relation: {
                                                    uiFilter: () => [
                                                        {
                                                            label: "Дата начала",
                                                            name: "nachaloSorevnovaniya",
                                                            type: "date",
                                                            filterType: "range",
                                                            sort: true,
                                                            filter: true,

                                                            sorted: "ASC",
                                                            filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
                                                        },
                                                        {   // Тип мероприятия
                                                            label: "Тип мероприятия",
                                                            name: "tipMeropriyatiya",
                                                            filterType: "group",
                                                            display: (o) => o.opisanie,
                                                            sort: true,
                                                            filter: true
                                                        },
                                                        {   // Уровень мероприятия
                                                            label: "Уровень мероприятия",
                                                            name: "urovenMeropriyatiya",
                                                            filterType: "group",
                                                            display: (o) => o.opisanie,
                                                            sort: true,
                                                            filter: true
                                                        },
                                                        {   // Место проведения
                                                            label: "Место проведения",
                                                            name: "mestoProvedeniya",
                                                            filterType: "group",
                                                            display: (o) => o.name,
                                                            sort: true,
                                                            filter: true
                                                        },
                                                    ],
                                                    displayString: (item) => {
                                                        return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
                                                    },
                                                    display: (item) => {
                                                        return (
                                                            <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                                                                <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                                                    <YImage item={item} width={32} hidePreview={true} />
                                                                </div>

                                                                <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                                                    <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                                                        <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                                                                    </div>
                                                                    <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                                                        <span style={{
                                                                            marginRight: "5px",
                                                                            borderRadius: "5px",

                                                                            // backgroundColor: "#f6214b",
                                                                            // color: "white",

                                                                            backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                                                            color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                                                                            fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",

                                                                            fontSize: "12px",


                                                                            boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                                                            padding: "2px 4px"
                                                                        }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                                                        <span>{item?.mestoProvedeniya?.name}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    },
                                                    reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                                                    type: "many-one",
                                                },
                                                queryFilter: [
                                                    QueryDetail("combobox"),
                                                    QueryOrder("nachaloSorevnovaniya", "DESC")
                                                ]
                                            }
                                            // {
                                            //     type: "func",
                                            //     render: (auth, item, context) => {
                                            //         return (<div>
                                            //             {context?.object?.text && <div style={{ padding: "0 0 8px" }}>
                                            //                 <div>Текст из VK</div>
                                            //                 <div style={{ maxHeight: "200px", overflow: "auto", backgroundColor: "#f8f8f8", border: "1px solid #e2e2e2", borderRadius: "6px", padding: "5px" }}>
                                            //                     {context?.object?.text && <pre>{context?.object?.text}</pre>}
                                            //                 </div>
                                            //             </div>}
                                            //         </div>)
                                            //     },
                                            // },
                                            // {
                                            //     label: "Текст поста",
                                            //     name: "editedText",
                                            //     type: "func",
                                            //     render: EmojiField,
                                            // },
                                        ]}
                                        mode={"func"}
                                        trigger={(click) => (
                                            <div onClick={click} style={{ display: "flex", flexDirection: "column", gap: "3px", flex: "1 1 auto", overflow: "hidden", textAlign: "left" }}>
                                                <Tooltip title={item.text.length > 350
                                                    ? `${item.text.substring(0, 350)}...`
                                                    : item.text}>
                                                    <div style={{
                                                        fontWeight: "bold",
                                                        textWrap: "nowrap",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                    }}>{item?.text}</div>
                                                </Tooltip>

                                                {item?.tipSsilkiDlyaSaita?.opisanie && <div style={{
                                                    fontSize: "11px", fontStyle: "italic", color: "rgba(0,0,0,.65)",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}><i className="fa fa-globe" style={{ fontSize: "10px", color: "blue" }}></i> {item?.tipSsilkiDlyaSaita?.opisanie}</div>}
                                                {item?.tekstSsilkiNaSaite && <div style={{
                                                    fontSize: "11px", fontStyle: "italic", color: "rgba(0,0,0,.65)",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}><i className="fa fa-font" style={{ fontSize: "10px", color: "blue" }}></i> {item?.tekstSsilkiNaSaite}</div>}
                                                {(!!item?.vkId && !!item?.vkOwnerId) && <div style={{
                                                    fontSize: "11px",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}>
                                                    <Link style={{ fontSize: "12px" }} onClick={e => e.stopPropagation()} target='_blank' href={`https://vk.com/wall${item?.vkOwnerId}_${item?.vkId}`}><i className="fa fa-external-link" style={{ fontSize: "11px" }}></i> Ссылка</Link>
                                                </div>}
                                                {(!!item?.meropriyatieID) && <div>
                                                    <Link style={{ fontSize: "12px" }} onClick={e => e.stopPropagation()} target='_blank' href={`/fed/event/${item?.meropriyatieID}`}><i className="fa fa-external-link" style={{ fontSize: "11px" }}></i> Ссылка на мероприятие</Link>
                                                </div>}

                                            </div>
                                        )}
                                    />


                                    {/* <div style={{ display: "flex", justifyContent: "flex-end", gap: "3px", flex: "0 0 50px" }}>
                                        <DropdownAction
                                            icon={<i className="fa fa-ellipsis-h" style={{ fontSize: "12px" }}></i>}
                                            buttonStyle={{ border: "none" }}
                                            items={[
                                                {
                                                    title: "Изменить",
                                                    mode: "MenuItem",
                                                    auth: auth,
                                                    modal: {
                                                        width: "650px"
                                                    },
                                                    options: {
                                                        initialValues: {
                                                            ...item
                                                        }
                                                    },
                                                    action: (values, unlock, close) => {
                                                        POSTFormData(auth, `/api/vkposts/createorupdate`,
                                                            makeFormData(
                                                                {
                                                                    ...item,
                                                                    ...values,
                                                                    masterID: master?.ID,
                                                                    serialized: JSON.stringify({ ...item, ...values, masterID: master?.ID, })
                                                                }),
                                                            ({ data }) => {
                                                                setCollection(o => updateInArray(o, data))
                                                                close();
                                                            },
                                                            (err) => errorCatch(err, unlock)
                                                        );
                                                    },
                                                    object: item,
                                                    form: Model,
                                                    meta: [
                                                        {
                                                            label: "Тип поста",
                                                            name: "tipPosta",
                                                            type: "object",
                                                            relation: {
                                                                display: (item) => {
                                                                    return item.nazvanie
                                                                },
                                                                reference: { object: "TipiPostov", property: "ID", source: "/api/tipipostov/list" },
                                                                type: "many-one",
                                                            },
                                                            queryFilter: [
                                                                QueryOrder("ID", "ASC")
                                                            ]
                                                        },
                                                        {
                                                            label: "Тип ссылки для сайта",
                                                            name: "tipSsilkiDlyaSaita",
                                                            type: "object",
                                                            relation: {
                                                                display: (item) => {
                                                                    return item.opisanie
                                                                },
                                                                reference: { object: "TipiSsilokVSotsSetyakh", property: "ID" },
                                                                type: "many-one",
                                                            },
                                                            queryFilter: [
                                                                QueryOrder("ID", "ASC")
                                                            ]
                                                        },
                                                        {
                                                            label: "Текст ссылки на сайте",
                                                            name: "tekstSsilkiNaSaite",
                                                            type: "string"
                                                        },
                                                        {
                                                            label: "Текст поста",
                                                            name: "tekst",
                                                            type: "func",
                                                            render: EmojiField,
                                                        },
                                                        // {
                                                        //     label: "Добавляемые файлы",
                                                        //     name: "file",
                                                        //     type: "files",
                                                        //     accept: ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .jpg, .png, .gif, .pdf, .xls, .xlsx, .txt, .svg, .mp4"
                                                        // }
                                                    ],
                                                },
                                                {
                                                    title: <span style={{ color: "red" }}>Удалить</span>,
                                                    auth: auth,
                                                    mode: "MenuItem",
                                                    action: (values, unlock, close) => {
                                                        Modal.confirm({
                                                            title: `Вы уверены что хотите удалить пост?`,
                                                            icon: <ExclamationCircleOutlined />,
                                                            content: <div>
                                                                <div style={{ fontWeight: "bold" }}>{item?.tipPosta?.nazvanie}</div>
                                                                <div style={{ fontSize: "11px", fontStyle: "italic", color: "rgba(0,0,0,.85)" }}>{item?.tipPosta?.kommentarii}</div>
                                                            </div>,
                                                            okText: "Да",
                                                            okType: 'danger',
                                                            cancelText: "Нет",
                                                            onOk: () => {
                                                                GET(auth, `/api/vkposts/delete/${item.ID}`,
                                                                    () => {
                                                                        setCollection(o => deleteInArray(o, item))
                                                                    }, errorCatch
                                                                );
                                                            },
                                                        });
                                                    }
                                                }
                                            ]} />
                                    </div> */}
                                </div>

                            </td>
                            <td className={`fixed fill`} style={{ left: "200px", minWidth: "50px", maxWidth: "50px", backgroundColor: "white", height: '1px' }}>
                                
                                    {statistika(all, events, published, viewed)}

                              
                            </td>
                            {JSXMap(groups, (group, cidx) => {
                                let o = item?.vkRepostOwnerPost?.find(e => e.ownerPostID == item?.ID && e.gruppaID == group?.ID)
                                return (<td className="wrap" style={{ fontWeight: "300", height: '1px', backgroundColor: "white" }} key={cidx}>
                                    <Action
                                        key="vkrepost"
                                        auth={auth}
                                        options={{
                                            initialValues: {
                                                ...o,
                                                // dataVremya: o?.dataVremya,
                                                // editedText: o?.editedText,
                                            }
                                        }}
                                        action={(values, unlock, close) => {

                                            POST(auth, `/api/vkrepost/set-meropriyatie`, {
                                                ...o,
                                                ...values,
                                                gruppaID: group?.ID,
                                                ownerPostID: item?.ID,
                                                // dataVremya: values.dataVremya,
                                            }, ({ data }) => {
                                                // setTableCells(o => updateInArray(o, data))
                                                update();
                                                close()
                                            }, err => errorCatch(err, unlock))
                                            // if (!o) {
                                            //     POST(auth, `/api/vkrepost/create`, {
                                            //         ...values,
                                            //         gruppaID: group?.ID,
                                            //         ownerPostID: item?.ID,
                                            //         dataVremya: values.dataVremya,
                                            //     }, ({ data }) => {
                                            //         // setTableCells(o => updateInArray(o, data))
                                            //         update();
                                            //         close()
                                            //     }, err => errorCatch(err, unlock))
                                            // } else if (values?.dataVremya) {
                                            //     POST(auth, `/api/vkrepost/update`, {
                                            //         ...o,
                                            //         // dataVremya: values.dataVremya,
                                            //         ...values
                                            //     }, ({ data }) => {
                                            //         // setTableCells(o => updateInArray(o, data))
                                            //         update();
                                            //         close()
                                            //     }, err => errorCatch(err, unlock))
                                            // } else {
                                            //     GET(auth, `/api/vkrepost/delete/${o.ID}`,
                                            //         () => {
                                            //             // setCollection(os => deleteInArray(os, o))
                                            //             update();
                                            //             close()
                                            //         }, err => errorCatch(err, unlock)
                                            //     );
                                            // }
                                        }}
                                        object={o}
                                        form={Model}
                                        meta={[
                                            {
                                                name: "prosmotreno",
                                                type: "func",
                                                render: (auth, item, value, onChange, onAfterChange) => {
                                                    return (<Checkbox disabled={(!!o.meropriyatieID)} onChange={(e) => {
                                                        onChange(!!(e?.target?.checked))
                                                    }} checked={value}>
                                                        Просмотрено
                                                    </Checkbox>)
                                                },
                                            },
                                            {
                                                label: "Мероприятие",
                                                name: "meropriyatie",
                                                type: "object",
                                                mode: "dialog",
                                                modal: { width: "650px" },
                                                relation: {
                                                    uiFilter: () => [
                                                        {
                                                            label: "Дата начала",
                                                            name: "nachaloSorevnovaniya",
                                                            type: "date",
                                                            filterType: "range",
                                                            sort: true,
                                                            filter: true,

                                                            sorted: "ASC",
                                                            filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
                                                        },
                                                        {   // Тип мероприятия
                                                            label: "Тип мероприятия",
                                                            name: "tipMeropriyatiya",
                                                            filterType: "group",
                                                            display: (o) => o.opisanie,
                                                            sort: true,
                                                            filter: true
                                                        },
                                                        {   // Уровень мероприятия
                                                            label: "Уровень мероприятия",
                                                            name: "urovenMeropriyatiya",
                                                            filterType: "group",
                                                            display: (o) => o.opisanie,
                                                            sort: true,
                                                            filter: true
                                                        },
                                                        {   // Место проведения
                                                            label: "Место проведения",
                                                            name: "mestoProvedeniya",
                                                            filterType: "group",
                                                            display: (o) => o.name,
                                                            sort: true,
                                                            filter: true
                                                        },
                                                    ],
                                                    displayString: (item) => {
                                                        return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
                                                    },
                                                    display: (item) => {
                                                        return (
                                                            <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                                                                <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                                                    <YImage item={item} width={32} hidePreview={true} />
                                                                </div>

                                                                <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                                                    <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                                                        <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                                                                    </div>
                                                                    <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                                                        <span style={{
                                                                            marginRight: "5px",
                                                                            borderRadius: "5px",

                                                                            // backgroundColor: "#f6214b",
                                                                            // color: "white",

                                                                            backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                                                            color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                                                                            fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",

                                                                            fontSize: "12px",


                                                                            boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                                                            padding: "2px 4px"
                                                                        }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                                                        <span>{item?.mestoProvedeniya?.name}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    },
                                                    reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                                                    type: "many-one",
                                                },
                                                queryFilter: [
                                                    QueryDetail("combobox"),
                                                    QueryOrder("nachaloSorevnovaniya", "DESC")
                                                ]
                                            },
                                            // {
                                            //     label: "Дата и время",
                                            //     name: "dataVremya",
                                            //     type: "datetime"
                                            // },
                                            // {
                                            //     label: "Тип ссылки для сайта",
                                            //     name: "tipSsilkiDlyaSaita",
                                            //     type: "object",
                                            //     relation: {
                                            //         display: (item) => {
                                            //             return item.opisanie
                                            //         },
                                            //         reference: { object: "TipiSsilokVSotsSetyakh", property: "ID" },
                                            //         type: "many-one",
                                            //     },
                                            //     queryFilter: [
                                            //         QueryOrder("ID", "ASC")
                                            //     ]
                                            // },
                                            // {
                                            //     label: "Текст ссылки на сайте",
                                            //     name: "tekstSsilkiNaSaite",
                                            //     type: "string"
                                            // },
                                            {
                                                type: "func",
                                                render: (auth, item, context) => {
                                                    return (<div>
                                                        {context?.object?.text && <div style={{ padding: "0 0 8px" }}>
                                                            <div>Текст из VK</div>
                                                            <div style={{ maxHeight: "200px", overflow: "auto", backgroundColor: "#f8f8f8", border: "1px solid #e2e2e2", borderRadius: "6px", padding: "5px" }}>
                                                                {context?.object?.text && <pre>{context?.object?.text}</pre>}
                                                            </div>
                                                        </div>}
                                                    </div>)
                                                },
                                            },
                                            // {
                                            //     label: "Текст поста",
                                            //     name: "editedText",
                                            //     type: "func",
                                            //     render: EmojiField,
                                            // },
                                        ]}
                                        mode={"func"}
                                        trigger={(click) => (
                                            <div onClick={(o) ? click : undefined} className={`bg ${(o && ((o?.ssilkaSotsSetiID && o?.meropriyatieID) || (o?.prosmotreno))) ? (!!o?.vkId) ? "bg-green dark-3 border-transparent pointer" : "bg-orange dark-3 border-transparent pointer" : (o) ? "bg-blue border-transparent pointer" : "bg-grey light-3 border-transparent pointer"}`}
                                                style={{ height: "100%", position: "relative" }}>
                                                {(o && o?.ssilkaSotsSetiID && o?.meropriyatieID) && <div style={{ position: "absolute", top: "5px", right: "5px" }}>
                                                    <Tooltip title={(!!o?.meropriyatieID) ? "Установлено мероприятие" : "Нет мероприятия"}>
                                                        <div className='bg bg-grey pointer' style={{ color: "rgba(0,0,0,.65)", minWidth: "15px", minHeight: "15px", display: "flex", justifyContent: "center", alignContent: "center", alignItems: "center" }}>
                                                            {(!!o?.meropriyatieID) && <i className="fa fa-check-square-o" style={{ color: "green" }}></i>}
                                                            {!o?.meropriyatieID && <i className="fa fa-square-o" style={{ color: "orangered" }}></i>}
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                                {(o && !o?.meropriyatieID && o?.prosmotreno) && <div style={{ position: "absolute", top: "5px", right: "5px" }}>
                                                    <Tooltip title={"Просмотрено"}>
                                                        <div className='bg bg-grey pointer' style={{ color: "rgba(0,0,0,.65)", minWidth: "15px", minHeight: "15px", display: "flex", justifyContent: "center", alignContent: "center", alignItems: "center" }}>
                                                            <i className="fa fa-check-square-o" style={{ color: "blue" }}></i>
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                                {/* <div>{(o?.dataVremya) ? <span><i className="fa fa-clock-o" style={{ fontSize: "11px" }}></i> <span style={{ fontStyle: (o?.faktVremyaPublikatsii) ? "normal" : "normal" }}>{dayjs(o?.dataVremya).format("DD.MM.YYYY HH:mm:ss")}</span></span> : undefined}</div> */}
                                                <div>{(o?.fakticheskayaDataPublikatsii) ? <span><i className="fa fa-check" style={{ fontSize: "11px", color: "green" }}></i> <span style={{ fontWeight: (o?.fakticheskayaDataPublikatsii) ? "bold" : "normal" }}>{dayjs(o?.fakticheskayaDataPublikatsii).format("DD.MM.YYYY HH:mm:ss")}</span></span> : undefined}</div>

                                                {(!!o?.vkId && !!o?.vkOwnerId) && <div>
                                                    <Link style={{ fontSize: "12px" }} onClick={e => e.stopPropagation()} target='_blank' href={`https://vk.com/wall${o?.vkOwnerId}_${o?.vkId}`}><i className="fa fa-external-link" style={{ fontSize: "11px" }}></i> Ссылка на пост</Link>
                                                </div>}
                                                {(!!o?.meropriyatieID) && <div>
                                                    <Link style={{ fontSize: "12px" }} onClick={e => e.stopPropagation()} target='_blank' href={`/fed/event/${o?.meropriyatieID}`}><i className="fa fa-external-link" style={{ fontSize: "11px" }}></i> Ссылка на мероприятие</Link>
                                                </div>}
                                            </div>
                                        )}
                                    />
                                </td>)
                            })}
                        </tr>)
                    })}
                </tbody>
            </table>
        </div>
    </div>)
}


export default function FederationadministratorPostsReposts(props) {
    const auth = useAuth();
    let [searchParams, setSearchParams] = useSearchParams();
    const onChangeRequestParameters = (value) => {
        if (value) {
            setSearchParams(value)
        }
    }
    const filters = React.useCallback(() => QueryParametersToFilters(searchParams, [
        {
            label: "Репост ID",
            name: "vkId",
            type: "int",
            sort: true,
            filter: true,
        },
        {
            label: "Группа ID",
            name: "gruppaID",
            type: "int",
            sort: true,
            filter: true,
        },
        {
            label: "Ориг. пост ID",
            name: "ownerPostID",
            type: "int",
            sort: true,
            filter: true,
        },
        {
            label: "Ориг. группа ID",
            name: "vkOwnerId",
            type: "int",
            sort: true,
            filter: true,
        },
        // {
        //     // name: "vkRepostOwnerPost.meropriyatie.ID",
        //     name: "is.event",
        //     alias: "vkRepostOwnerPost.meropriyatie.ID",
        //     sort: true,
        //     filter: true,
        //     label: "Есть мероприятие",
        //     type: "object",
        //     relation: {
        //         display: (item) => {
        //             return item.name
        //         },
        //         reference: {
        //             data: [
        //                 { ID: "1", name: "Да" },
        //                 { ID: "2", name: "Нет" },
        //             ]
        //         },
        //         type: "many-one",
        //     },
        //     queryComparer: (value, item) => {
        //         // console.log(value,item);

        //         if (value == "1") {
        //             console.log("sfcasdsv", value, item);
        //             return "nnu"
        //         } else if (value == "2") {
        //             return "nu"
        //         }
        //         return ""
        //     }
        // },
        {
            name: "hasevent",
            sort: false,
            filter: true,
            label: "Есть мероприятие",
            type: "object",
            relation: {
                display: (item) => {
                    return item.name
                },
                reference: {
                    property: "ID",
                    data: [
                        { ID: "1", name: "Да" },
                        { ID: "2", name: "Нет" },
                    ]
                },
                type: "many-one",
            },
            queryRaw: (value, item, key) => {
                if (value == "1") {
                    return QueryParam("w-nnu-vkRepostOwnerPost.meropriyatie.ID", "true")

                } else if (value == "2") {
                    return QueryParam("w-nu-vkRepostOwnerPost.meropriyatie.ID", "false")
                }
                return ""
            },
            // filtered: "2",
        },
        {
            name: "vseprosmotreno",
            sort: false,
            filter: true,
            label: "Все просмотрено",
            type: "object",
            relation: {
                display: (item) => {
                    return item.name
                },
                reference: {
                    property: "ID",
                    data: [
                        { ID: "1", name: "Да" },
                        { ID: "2", name: "Нет" },
                    ]
                },
                type: "many-one",
            },
            queryRaw: (value, item, key) => {
                if (value == "1") {
                    return QueryParam("w-vkRepostOwnerPost.prosmotreno", "true")

                } else if (value == "2") {
                    return QueryParam("w-vkRepostOwnerPost.prosmotreno", "false")
                }
                return ""
            },
            // filtered: "2",
        },
        {
            name: "ispolnen",
            sort: true,
            filter: true,
            // label: "Исполнен",
            type: "object",
            relation: {
                display: (item) => {
                    return item.name
                },
                reference: {
                    data: [
                        { ID: "1", name: "Да" },
                        { ID: "2", name: "Нет" },
                    ]
                },
                type: "many-one",
            },
            queryRaw: (value, item, key) => {
                if (value == "1") {
                    return QueryParam("w-" + key, "true")
                } else if (value == "2") {
                    return QueryParam("w-" + key, "false")
                }
                return ""
            },
            filtered: "2",
        },
    ]), [searchParams]);
    const ConvertFilterToQueryParameters = useCallback((value) => {
        if (onChangeRequestParameters) {
            onChangeRequestParameters(FilterToQueryParameters(filters(), value.filter, value.sorting, value.page, value.count))
        }
    }, [onChangeRequestParameters])
    const QueryParametersToPage = useCallback(() => {
        if (searchParams)
            return searchParams.get("page") || 1;
    }, [searchParams]);
    const QueryParametersToPageCount = useCallback(() => {
        if (searchParams)
            return searchParams.get("count") || 15;
    }, [searchParams]);
    const FilterFromContextFilter = React.useCallback(() => [
        // QueryParam("w-nu-OrganizatorFederatsiya", 0),
        // If((dance && dance.length > 0), QueryParam("w-in-KategoriiUchastnikovNaMeropriyatiyakhMeropriyatie.TantsevalnayaDistsiplina.VidTantsa.Tanets", dance?.join(","))),
    ], []);

    const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

    return (
        <PageLayout hideSider={true}>
            <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ padding: "10px" }}>
                    <CollectionServer
                        auth={auth}
                        name={"VkOwnerRepost"}
                        source={`/api/vkownerrepost/list`}
                        contextFilters={FilterFromContextFilter}
                        filters={filters}
                        floatingFilter={true}

                        onChangeRequestParameters={ConvertFilterToQueryParameters}
                        page={QueryParametersToPage}
                        count={QueryParametersToPageCount}
                        size={"small"}

                        customRender={(items, {
                            collection,
                            setCollection,
                            setCollectionItem,
                            removeCollectionItem,
                            collectionActions,
                            modelActions,
                            update
                        }) => (<div>
                            <VkRepostsTable
                                auth={auth}
                                collection={items}
                                setCollection={setCollection}
                                setCollectionItem={setCollectionItem}
                                removeCollectionItem={removeCollectionItem}
                                collectionActions={collectionActions}
                                modelActions={modelActions}
                                update={update}
                            />
                            {/* {JSXMap(items, (item, idx) => {
                                return (<div key={idx}>
                                    
                                    <EventListItem
                                        key={idx}
                                        event={item?.meropriyatie}
                                        // qr={item.Data}
                                        // tickets={ticket()}

                                        // adminButton={true}
                                        hideBuyButton={true}
                                        hideDetailButton={true}

                                        extButtons={({ path, size, style }) => (
                                            <div>
                                                <Space.Compact>
                                                    <Button size='small' className={`btn btn-soft-secondary btn-sm`} style={style} href={`${path(1)}/${item.ID}`}>Перейти в мастер</Button>
                                                    <DropdownAction
                                                        // style={{ padding: "0" }}
                                                        button={() => (<div className={`bg bg-grey pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                            <i className="fa fa-ellipsis-h"></i>
                                                        </div>)}
                                                        items={modelActions(item, idx)?.map((e, idx) => ({
                                                            key: e.key || idx,
                                                            auth: auth,
                                                            mode: "MenuItem",
                                                            object: item,
                                                            collection: collection,
                                                            setCollection: setCollection,
                                                            ...e
                                                        }))} />
                                                </Space.Compact>
                                            </div>
                                        )}
                                        size={"medium"}
                                    />
                                </div>)
                            })} */}
                        </div>)}

                    // collectionActions={() => [{
                    //     auth: auth,
                    //     action: (values, unlock, close, { collection, setCollection }) => {
                    //         POST(auth, `/api/mastervkpostov/create`, values,
                    //             ({ data }) => {
                    //                 setCollection(updateInArray(collection, data, true));
                    //                 close();
                    //             }, (err) => errorCatch(err, unlock)
                    //         );
                    //     },
                    //     title: "Создать",
                    //     modal: {
                    //         title: "Создание мастера",
                    //         width: "650px"
                    //     },
                    //     // form: ModernUserSelection,
                    //     form: Model,
                    //     meta: [
                    //         {
                    //             label: "Мероприятие",
                    //             name: "meropriyatie",
                    //             type: "object",
                    //             mode: "dialog",
                    //             modal: { width: "650px" },
                    //             relation: {
                    //                 uiFilter: () => [
                    //                     {
                    //                         label: "Дата начала",
                    //                         name: "nachaloSorevnovaniya",
                    //                         type: "date",
                    //                         filterType: "range",
                    //                         sort: true,
                    //                         filter: true,

                    //                         sorted: "ASC",
                    //                         filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
                    //                     },
                    //                     {   // Тип мероприятия
                    //                         label: "Тип мероприятия",
                    //                         name: "tipMeropriyatiya",
                    //                         filterType: "group",
                    //                         display: (o) => o.opisanie,
                    //                         sort: true,
                    //                         filter: true
                    //                     },
                    //                     {   // Уровень мероприятия
                    //                         label: "Уровень мероприятия",
                    //                         name: "urovenMeropriyatiya",
                    //                         filterType: "group",
                    //                         display: (o) => o.opisanie,
                    //                         sort: true,
                    //                         filter: true
                    //                     },
                    //                     {   // Место проведения
                    //                         label: "Место проведения",
                    //                         name: "mestoProvedeniya",
                    //                         filterType: "group",
                    //                         display: (o) => o.name,
                    //                         sort: true,
                    //                         filter: true
                    //                     },
                    //                 ],
                    //                 displayString: (item) => {
                    //                     return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
                    //                 },
                    //                 display: (item) => {
                    //                     return (
                    //                         <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                    //                             <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                    //                                 <YImage item={item} width={32} hidePreview={true} />
                    //                             </div>

                    //                             <div style={{ flex: "auto", paddingLeft: "7px" }}>
                    //                                 <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                    //                                     <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                    //                                 </div>
                    //                                 <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                    //                                     <span style={{
                    //                                         marginRight: "5px",
                    //                                         borderRadius: "5px",

                    //                                         // backgroundColor: "#f6214b",
                    //                                         // color: "white",

                    //                                         backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                    //                                         color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                    //                                         fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",

                    //                                         fontSize: "12px",


                    //                                         boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                    //                                         padding: "2px 4px"
                    //                                     }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                    //                                     <span>{item?.mestoProvedeniya?.name}</span>
                    //                                 </div>
                    //                             </div>
                    //                         </div>
                    //                     )
                    //                 },
                    //                 reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                    //                 type: "many-one",
                    //             },
                    //             queryFilter: [
                    //                 QueryDetail("combobox"),
                    //                 QueryOrder("nachaloSorevnovaniya", "DESC")
                    //             ]
                    //         },
                    //     ],
                    // }]}
                    // modelActions={(item) => {
                    //     return [
                    //         {
                    //             auth: auth,
                    //             action: (values, unlock, close, { collection, setCollection }) => {
                    //                 POST(auth, `/api/mastervkpostov/update`, { ...values, ID: item?.ID },
                    //                     ({ data }) => {
                    //                         setCollection(updateInArray(collection, data, true));
                    //                         close();
                    //                     }, (err) => errorCatch(err, unlock)
                    //                 );
                    //             },
                    //             title: "Изменить",
                    //             modal: {
                    //                 title: "Изменение мастер постов",
                    //                 width: "650px"
                    //             },
                    //             form: Model,
                    //             meta: [
                    //                 {
                    //                     label: "Мероприятие",
                    //                     name: "meropriyatie",
                    //                     type: "object",
                    //                     mode: "dialog",
                    //                     modal: { width: "650px" },
                    //                     relation: {
                    //                         uiFilter: () => [
                    //                             {
                    //                                 label: "Дата начала",
                    //                                 name: "nachaloSorevnovaniya",
                    //                                 type: "date",
                    //                                 filterType: "range",
                    //                                 sort: true,
                    //                                 filter: true,

                    //                                 sorted: "ASC",
                    //                                 filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
                    //                             },
                    //                             {   // Тип мероприятия
                    //                                 label: "Тип мероприятия",
                    //                                 name: "tipMeropriyatiya",
                    //                                 filterType: "group",
                    //                                 display: (o) => o.opisanie,
                    //                                 sort: true,
                    //                                 filter: true
                    //                             },
                    //                             {   // Уровень мероприятия
                    //                                 label: "Уровень мероприятия",
                    //                                 name: "urovenMeropriyatiya",
                    //                                 filterType: "group",
                    //                                 display: (o) => o.opisanie,
                    //                                 sort: true,
                    //                                 filter: true
                    //                             },
                    //                             {   // Место проведения
                    //                                 label: "Место проведения",
                    //                                 name: "mestoProvedeniya",
                    //                                 filterType: "group",
                    //                                 display: (o) => o.name,
                    //                                 sort: true,
                    //                                 filter: true
                    //                             },
                    //                         ],
                    //                         displayString: (item) => {
                    //                             return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
                    //                         },
                    //                         display: (item) => {
                    //                             return (
                    //                                 <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                    //                                     <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                    //                                         <YImage item={item} width={32} hidePreview={true} />
                    //                                     </div>

                    //                                     <div style={{ flex: "auto", paddingLeft: "7px" }}>
                    //                                         <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                    //                                             <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                    //                                         </div>
                    //                                         <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                    //                                             <span style={{
                    //                                                 marginRight: "5px",
                    //                                                 borderRadius: "5px",

                    //                                                 // backgroundColor: "#f6214b",
                    //                                                 // color: "white",

                    //                                                 backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                    //                                                 color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                    //                                                 fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",

                    //                                                 fontSize: "12px",


                    //                                                 boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                    //                                                 padding: "2px 4px"
                    //                                             }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                    //                                             <span>{item?.mestoProvedeniya?.name}</span>
                    //                                         </div>
                    //                                     </div>
                    //                                 </div>
                    //                             )
                    //                         },
                    //                         reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                    //                         type: "many-one",
                    //                     },
                    //                     queryFilter: [
                    //                         QueryDetail("combobox"),
                    //                         QueryOrder("nachaloSorevnovaniya", "DESC")
                    //                     ]
                    //                 },
                    //             ],
                    //         },
                    //         {
                    //             auth: auth,
                    //             title: <span style={{ color: "red" }}>Удалить</span>,
                    //             action: (values, unlock, close, { collection, setCollection }) => {
                    //                 confirmKey({
                    //                     pass: '723',
                    //                     title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить мастер</span>,
                    //                     icon: undefined,
                    //                     content: <div>
                    //                         <div>Вы действительно хотите удалить мастер постов?</div>
                    //                         <div style={{ fontSize: "14px", fontWeight: "bold" }}>{item?.nazvanie} </div>
                    //                     </div>,
                    //                     okText: 'Удалить',
                    //                     cancelText: 'Отмена',
                    //                     onOk() {
                    //                         return new Promise((resolve, reject) => {
                    //                             GET(auth, '/api/mastervkpostov/delete/' + item.ID,
                    //                                 ({ data }) => {
                    //                                     setCollection(deleteInArray(collection, item));
                    //                                     resolve(data);
                    //                                 }, (err) => errorCatch(err, reject));
                    //                         }).catch(() => { });
                    //                     },
                    //                     onCancel() {
                    //                     },
                    //                 })
                    //             }
                    //         }
                    //     ]
                    // }}
                    />
                </div>
            </div>
        </PageLayout>
    );
}
